'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { ArticlesBlock } from '@/components/ArticlesBlock';
import HorizontalLogo from '@/shared/assets/logo_horizontal.svg?svg';
import { Sidebar } from '../Sidebar';
import styles from './MobileMenu.module.css';

export const MobileMenu = ({
  className,
  isOpen,
  onClose,
  ...props
}: {
  className: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const lastPathRef = useRef<string>('');

  const pathname = usePathname();

  useEffect(() => {
    if (!lastPathRef.current) {
      lastPathRef.current = pathname;
    } else if (lastPathRef.current !== pathname) {
      onClose();
      lastPathRef.current = pathname;
    }
  }, [pathname, onClose, isOpen, lastPathRef]);

  return (
    <div className={clsx(styles.root, className)} {...props}>
      <Link className={styles.link} href="/">
        <HorizontalLogo className={styles.logo} />
      </Link>
      <Sidebar />
      <ArticlesBlock className={styles.topics} />
    </div>
  );
};
